import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=5da6da9a&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da6da9a')) {
      api.createRecord('5da6da9a', component.options)
    } else {
      api.reload('5da6da9a', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=5da6da9a&", function () {
      api.rerender('5da6da9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/purchase-activity/Filters.vue"
export default component.exports